import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fortnox = defineConnector({
  identifier: "fortnox",
  name: "Fortnox",
  tagLine: "Cloud accounting software",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.fortnox\\.se/3/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Fortnox app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Fortnox authentication docs](https://developer.fortnox.se/get-started/authentication/) and register an application in the Fortnox developer portal. Copy the client ID and client secret from the app settings.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/fortnox/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Fortnox account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Fortnox account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://apps.fortnox.se/oauth-v1/auth",
    tokenEndpoint: () => "https://apps.fortnox.se/oauth-v1/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.fortnox.se/3/",
  },
});
